import React, { forwardRef } from "react";
import PropTypes from "prop-types";

import { RefElement } from "@/types/react";
import { TextLink, TextLinkProps } from "../TextLink";

import styles from "./Notification.scss";

type NotificationLinkBaseProps = {
  href?: string;
};
export type NotificationLinkProps = NotificationLinkBaseProps &
  Omit<TextLinkProps, keyof NotificationLinkBaseProps>;

type TextLinkRefElement = RefElement<typeof TextLink>;

// eslint-disable-next-line tree-shaking/no-side-effects-in-initialization
export const NotificationLink = forwardRef<
  TextLinkRefElement,
  NotificationLinkProps
>(({ href, children, ...restProps }, ref) => (
  <div className={styles["link-container"]}>
    <TextLink
      href={href}
      variants={TextLink.Variant.highlight}
      ref={ref}
      {...restProps}
    >
      {children}
    </TextLink>
  </div>
));

NotificationLink.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  href: PropTypes.string,
};

NotificationLink.defaultProps = {
  href: "#",
};

NotificationLink.displayName = "Notification.Link";

export default NotificationLink;
